import { AppAreaConfig } from '@/funnels/@types'
import maleChairTaiChi from './activity-male-chair-tai-chi'
import femaleChairTaiChiFwf from './activity-female-chair-tai-chi-fwf'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-chair-tai-chi-pr',
	landing: {
		ids: ['loader-chair-tai-chi-pr', 'age-chair-tai-chi-pr'],
		route: {
			path: '/chair-tai-chi-pr',
			name: 'main-chair-tai-chi-pr-funnel',
		},
	},
	funnel: {
		id: 'ob-chair-tai-chi-pr',
		route: {
			path: '/chair-tai-chi-pr/ob/:page(.*)?',
			name: 'main-chair-tai-chi-pr',
		},
		slug: 'main-chair-tai-chi-pr',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			sex: {
				male: { appArea: maleChairTaiChi },
				female: { appArea: femaleChairTaiChiFwf },
			},
		},
	},
}

export default appAreaConfig
